import { render, staticRenderFns } from "./Clinic.vue?vue&type=template&id=5a7deb52&scoped=true"
import script from "./Clinic.vue?vue&type=script&lang=js"
export * from "./Clinic.vue?vue&type=script&lang=js"
import style0 from "./Clinic.vue?vue&type=style&index=0&id=5a7deb52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7deb52",
  null
  
)

export default component.exports